export const OverviewIcon = ({ className }: { className?: string }) => (
   <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="21"
      viewBox="0 0 22 21"
      fill="none"
      className={className}
   >
      <g clipPath="url(#clip0_66_237)">
         <path
            d="M21.2305 10.5C21.2305 10.983 20.8393 11.375 20.3555 11.375H18.1977C17.8022 11.375 17.4548 11.6419 17.3525 12.0225L15.8851 17.4842C15.718 18.0311 15.2507 18.375 14.7117 18.375H14.6968C14.1517 18.3689 13.6862 18.0119 13.5383 17.4877L10.6736 5.915L7.89284 15.7491C7.72572 16.2715 7.28909 16.6031 6.77284 16.6232C6.23734 16.6521 5.79372 16.3476 5.59597 15.869L4.19597 11.9542C4.07084 11.6077 3.74009 11.3741 3.37172 11.3741H1.10547C0.621594 11.3741 0.230469 10.9821 0.230469 10.4991C0.230469 10.0161 0.621594 9.62412 1.10547 9.62412H3.37259C4.47859 9.62412 5.47084 10.3232 5.84447 11.3645L6.66522 13.6622L9.53872 3.49912C9.71459 2.95225 10.1748 2.6005 10.7296 2.62412C11.2703 2.63375 11.7323 2.98987 11.8802 3.50962L14.7318 15.0299L15.6611 11.5684C15.9682 10.4239 17.0103 9.62412 18.196 9.62412H20.3537C20.8376 9.62412 21.2287 10.0161 21.2287 10.4991L21.2305 10.5Z"
            fill="white"
         />
      </g>
      <defs>
         <clipPath id="clip0_66_237">
            <rect
               width="21"
               height="21"
               fill="white"
               transform="translate(0.230469)"
            />
         </clipPath>
      </defs>
   </svg>
)
